export enum SIGNUP_ROLES {
  rep = 'foam-manager',
  creator = 'foam-creator',
  creatorManaged = 'foam-managed-creator',
  brandUser = 'echo-brand-user',
}
